/** Checklist copy for Leads / lead detail context; replace with CMS/API when available. */
export interface HelpGettingStartedItem {
  id: string;
  label: string;
}

export const HELP_LEAD_DETAIL_GETTING_STARTED: HelpGettingStartedItem[] = [
  { id: 'review-tabs', label: 'Review each tab to understand lead data' },
  { id: 'follow-up', label: 'Use follow-up to schedule next actions' },
  { id: 'edit-fields', label: 'Edit lead details when information changes' },
];
